import App from './app'
import React from 'react'
import ReactDOM from 'react-dom'
import { GoogleApiProvider } from 'react-gapi'
import { CssBaseline, GeistProvider, Page } from '@geist-ui/react'

console.log('userAgent:', navigator.userAgent)
ReactDOM.render(
  <React.StrictMode>
    <GeistProvider>
      <CssBaseline />
      <GoogleApiProvider clientId="524758991649-us5crbpm6el3jkc51e4d5nh7mq1frkp3.apps.googleusercontent.com">
        <Page>
          <App />
        </Page>
      </GoogleApiProvider>
    </GeistProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)
